import React from 'react';
import { Feature } from '@tencent/workbench';
import type { IAnonymousViewFeature } from './anonymous-view-interface';
import { SwitchAnonymousView } from '@src/framework/frame-pc/components/switch-anonymous-view';
import { tdwWithVip } from '@src/js/common/ark-extensions/dc-components/vip-linktext';
import { IAnonymousViewService } from '@src/slide/application/service/anonymous-view-service';
import { showTips, showWhenSVipExpired } from '@src/framework/frame-pc/components/vip-tips';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

@Feature()
export class AnonymousViewFeature implements IAnonymousViewFeature {
    private anonymousViewService: IAnonymousViewService;
    private isInit = false;

    public getDescription() {
        return (
            <SwitchAnonymousView
                handleSwitch={this.handleSwitch}
                anonymousViewService={this.anonymousViewService}
            />
        );
    }

    public initAnonymousService = async () => {
        const service = await this.getAnonymousService();
        this.anonymousViewService = service;
        this.showAnonymousViewTips();
        this.anonymousViewService.listenStatusChange();
    };

    public handleSwitch = async () => {
        tdwWithVip({
            module: this.anonymousViewService.anonymousStatus ? 'close' : 'entrance',
            opername: 'doc_vip_invisible',
            action: 'click',
            ver9: 'pc_titlebar',
        });

        this.anonymousViewService.setAnonymousViewStatus();
    };

    private showAnonymousViewTips = async () => {
        this.anonymousViewService.events.on('ANONYMOUS_CHANGE', () => {
            // 展示提示
            if (this.anonymousViewService.isExpired) {
                // 提示：会员已过期，隐身查看失效
                showWhenSVipExpired();
                return;
            }

            if (this.isInit) {
                // 页面已经加载过了，再改变隐身状态时，提示： 已开启隐身查看、已取消隐身查看
                showTips(this.anonymousViewService.anonymousStatus, 'NEXT');
                return;
            }

            // 页面初次加载时，如果之前已经设置了隐身状态，提示：正在隐身查看
            if (this.anonymousViewService.anonymousStatus) {
                showTips(true, 'INIT');
            }
        });

        await this.anonymousViewService.getAnonymousViewStatus();
        this.anonymousViewService.events.emit('ANONYMOUS_CHANGE');
        this.isInit = true;
    };

    private async getAnonymousService(): Promise<IAnonymousViewService> {
        const anonymousViewService = await this.getAppServices().viewableServiceLayer.anonymousViewService.promise();
        return anonymousViewService;
    }

    private getAppServices(): IPcEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }
}
